var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-section-footer"},[_c('base-svg',{staticClass:"logo",attrs:{"name":"logo"}}),_c('div',{staticClass:"signal-wrapper"},[_c('base-font',[_vm._v("Designed For")]),(this.value)?_c('base-font',{staticClass:"logo"},[_vm._v(_vm._s(_vm.logo))]):_c('base-svg',{attrs:{"name":"teltonika-logo"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }